import React from 'react';

import { ResponsiveTypography } from 'app/components/common/typography';
import { TypographyProps } from 'app/components/common/typography/typography';
import { typographyRules } from 'app/components/domain/typography/typography-rules';

export const Typography: React.FC<TypographyProps> = (props) => (
    <ResponsiveTypography {...props} rules={typographyRules} />
);
